var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showPostingSection
    ? _c(
        "section",
        { staticClass: "w-full" },
        [
          _c("PostingHeader", {
            attrs: {
              posting: _vm.posting,
              companyId: _vm.company.id,
              managerId: _vm.managerId,
              isManager: _vm.isManager,
            },
            on: { removePosting: _vm.removePosting },
          }),
          _c("div", { staticClass: "h-full w-full pt-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col w-full h-full customShadow bg-white",
              },
              [
                _c("TabsWithRoutes", {
                  staticClass: "job_posting_tabs",
                  attrs: { routeTabs: _vm.routeTabs },
                  scopedSlots: _vm._u(
                    [
                      _vm.allApplicantsNumber
                        ? {
                            key: _vm.routes.RECRUITING_POSTING_APPLICATIONS,
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-1.5" }, [
                                  _vm._v("All applications"),
                                ]),
                                _c("TabNotificationBubble", {
                                  attrs: {
                                    notification: _vm.allApplicantsNumber,
                                    info: "",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      _vm.underReviewApplicantsNumber
                        ? {
                            key: _vm.routes.RECRUITING_POSTING_REVIEW,
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-1.5" }, [
                                  _vm._v("Under Review"),
                                ]),
                                _c("TabNotificationBubble", {
                                  attrs: {
                                    notification:
                                      _vm.underReviewApplicantsNumber,
                                    info: "",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      _vm.approvedApplicantsNumber
                        ? {
                            key: _vm.routes.RECRUITING_POSTING_APPROVED,
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-1.5" }, [
                                  _vm._v("Approved"),
                                ]),
                                _c("TabNotificationBubble", {
                                  attrs: {
                                    notification: _vm.approvedApplicantsNumber,
                                    info: "",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      _vm.declinedApplicantsNumber
                        ? {
                            key: _vm.routes.RECRUITING_POSTING_DECLINED,
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-1.5" }, [
                                  _vm._v("Declined"),
                                ]),
                                _c("TabNotificationBubble", {
                                  attrs: {
                                    notification: _vm.declinedApplicantsNumber,
                                    info: "",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      _vm.getWithdrawNumbers
                        ? {
                            key: _vm.routes.RECRUITING_POSTING_CANCELLED,
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-1.5" }, [
                                  _vm._v("Withdrawn"),
                                ]),
                                _c("TabNotificationBubble", {
                                  attrs: {
                                    notification: _vm.getWithdrawNumbers,
                                    info: "",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                }),
                _vm.posting
                  ? _c("router-view", {
                      staticClass: "h-full",
                      attrs: {
                        postingId: _vm.posting.id,
                        jobTitle: _vm.posting.job_title,
                        description: _vm.posting.description,
                        industries: _vm.posting.industries,
                        skills: _vm.posting.skills,
                        status: _vm.posting.active,
                        isPublic: _vm.posting.public,
                        company: _vm.company,
                        currentUser: _vm.currentUser,
                      },
                      on: { applicationCollectionUpdated: _vm.handleRefetch },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }